// import axios from 'axios'
import $ from 'jquery'
import url from '../url'

function fetch (postalCode) {
  if (process.browser) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: url.address,
        type: 'get',
        dataType: 'json',
        data: {
          searchVal: postalCode,
          returnGeom: 'N',
          getAddrDetails: 'Y',
          pageNum: '1'
        }
      })
        .done(function (result) {
          resolve(result)
        })
    })
  }

  // return new Promise((resolve, reject) => {
  //   axios({
  //     method: 'GET',
  //     url: url.address,
  //     data: {
  //       searchVal: postalCode,
  //       returnGeom: 'N',
  //       getAddrDetails: 'Y',
  //       pageNum: '1'
  //     },
  //     dataType: 'json'
  //   })
  //     .then(response => {
  //       resolve(response)
  //     })
  // })
}

export default {
  getAddress (postalCode) {
    return fetch(postalCode)
  }
}



// WEBPACK FOOTER //
// ./src/api/home/address.js